// Configurazione centralizzata dei servizi per la HomePage e altre sezioni.
// Categorie: home (casa), auto (veicoli), business (aziende)

export const homeServices = [
  { path: '/lavaggio-divani', icon: '🛋️', title: 'Divani', desc: 'Lavaggio, smacchiatura e odori', price: 'Da €40' },
  { path: '/lavaggio-tappezzeria', icon: '🪑', title: 'Tappezzeria', desc: 'Poltrone, sedie, testiere e pouf', price: 'Su preventivo' },
  { path: '/lavaggio-materassi', icon: '🛏️', title: 'Materassi', desc: 'Lavaggio e igienizzazione', price: 'Da €59' },
  { path: '/lavaggio-tappeti', icon: '🧶', title: 'Tappeti', desc: 'Lavaggio a domicilio', price: 'Da €30' },
  { path: '/lavaggio-moquette', icon: '🏠', title: 'Moquette', desc: 'Pulizia in posa', price: 'Da €5/mq' },
  { path: '/pulizia-vetri-tapparelle', icon: '🪟', title: 'Finestre & Tapparelle', desc: 'Senza aloni e smontaggio', price: 'Da €60' },
  { path: '/lavaggio-tende', icon: '🪟', title: 'Tende Interne', desc: 'Anti-acaro senza smontaggio', price: 'Da €40' },
  { path: '/pulizia-tende-sole-bologna', icon: '🌞', title: 'Tende da Sole', desc: 'Senza smontarle', price: 'Da €80' },
  { path: '/pulizia-cucine', icon: '🍳', title: 'Cucine', desc: 'Sgrassante a vapore', price: 'Da €70' },
];

export const autoServices = [
  {
    path: '/lavaggio-auto-vapore-bologna',
    icon: '✨',
    title: 'Auto Detailing a Vapore',
    desc: 'Pacchetti START, PRO, ELITE',
    price: 'Da €79',
    featured: true,
    badge: 'NUOVO',
  },
  { path: '/pulizia-interni-auto-bologna', icon: '🚗', title: 'Interni Auto', desc: 'Sanificazione completa', price: 'Da €35' },
  { path: '/lavaggio-moto-vapore', icon: '🏍️', title: 'Moto', desc: 'Lavaggio e detailing a vapore', price: 'Su preventivo' },
  { path: '/lavaggio-camper-vapore', icon: '🚐', title: 'Camper', desc: 'Pulizia esterna e interna', price: 'Da €80' },
  { path: '/lavaggio-barche-vapore', icon: '⛵', title: 'Barche e Nautica', desc: 'Comacchio, Ravenna, Cervia, Rimini', price: 'Su preventivo' },
  { path: '/sanificazione-aerei-jet-privati', icon: '✈️', title: 'Aerei e Jet Privati', desc: 'Sanificazione cabine e interni', price: 'Su preventivo' },
  { path: '/pulizia-bus-flotte-bologna', icon: '🚌', title: 'Flotte e Bus', desc: 'Servizio B2B per mezzi aziendali', price: 'Su richiesta' },
];

export const businessServices = [
  {
    path: '/pulizia-bus-flotte-bologna',
    icon: '🚛',
    title: 'Flotte Auto e Furgoni',
    desc: 'Servizio dedicato per aziende con flotte aziendali. Sanificazione e detailing in sede.',
    price: 'Preventivo dedicato',
    featured: true,
    badge: 'TOP',
  },
  { path: '/flotte-aziendali-vapore', icon: '🏭', title: 'Flotte Aziendali', desc: 'Contratti su misura', price: 'Su richiesta' },
  { path: '/autobus-trasporto-vapore', icon: '🚌', title: 'Autobus & Trasporti', desc: 'Sanificazione mezzi pubblici', price: 'Su richiesta' },
  { path: '/hotel-bb-pulizia-vapore', icon: '🏨', title: 'Hotel & B&B', desc: 'Igienizzazione camere', price: 'Su richiesta' },
  { path: '/ristoranti-locali-vapore', icon: '🍽️', title: 'Ristoranti & Locali', desc: 'Cucine e sale', price: 'Su richiesta' },
  { path: '/lavaggio-finestre-aziende-bologna', icon: '🏢', title: 'Vetrate Aziendali', desc: 'Uffici e showroom', price: 'Su richiesta' },
];

export const featuredLanding = {
  path: '/lavaggio-auto-vapore-bologna',
  badge: '🔥 IN PROMOZIONE',
  title: 'Lavaggio Auto a Vapore — Pacchetti START · PRO · ELITE',
  desc: 'Il nuovo servizio di Auto Detailing a vapore a Bologna. Igienizzazione interni ed esterni senza chimica, direttamente a casa o in ufficio.',
  cta: 'Scopri i pacchetti',
  image: '/images/lavaggio-a-vapore-interni-auto-eco-vapor-pro.webp',
  priceFrom: 'Da €79',
  bullets: [
    'Pacchetto START da €79 — pulizia completa interno + esterno',
    'Pacchetto PRO da €129 — igienizzazione profonda + detailing',
    'Pacchetto ELITE da €179 — full steam detailing premium',
  ],
};
